module.exports = __webpack_public_path__ + "media/bootstrap-icons/bootstrap-reboot-d51077be.svg";